import { PaginaOperaciones } from '../components/PaginaOperaciones'
import type { Ruta } from '../types'

export default function Rutas() {
  return (
    <PaginaOperaciones<Ruta>
      titulo="Rutas"
      recurso="rutas"
      llave="id"
      columnas={[
        { campo: 'folio', titulo: 'Folio' },
        { campo: 'embarqueFolio', titulo: 'Embarque' },
        { campo: 'vehiculoPlaca', titulo: 'Vehiculo' },
        { campo: 'transportistaNombre', titulo: 'Transportista' },
        { campo: 'estado', titulo: 'Estado' },
        { campo: 'fecha', titulo: 'Fecha', render: (r) => r.fecha?.split('T')[0] || '-' },
      ]}
      campos={[]}
      valorInicial={{}}
      puedeCrear={false}
      acciones={[
        {
          label: 'Asignar',
          endpoint: (r) => `rutas/${r.id}/asignar`,
          body: (r) => ({ id: r.id, estado: 'Asignada' })
        },
        {
          label: 'Confirmar',
          endpoint: (r) => `rutas/${r.id}/confirmar`,
          body: (r) => ({ id: r.id, estado: 'Confirmada' }),
          metodo: 'PUT'
        }
      ]}
    />
  )
}
